module.exports = {"441203001":"坑口街道","441203002":"桂城街道","441203003":"广利街道","441203101":"永安镇","441203102":"沙浦镇","441203103":"凤凰镇","441203104":"莲花镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441203.json
// module id = 2012
// module chunks = 0